import { forwardRef, ReactNode } from 'react';

export const testId = 'nsTitleTestId';

type NsTitleProps = {
  className?: string;
  title: string | number | ReactNode;
  id?: string;
};

export const NsTitle = forwardRef<HTMLHeadingElement, NsTitleProps>(({ title, id }, ref) => (
  <h1 id={id} data-testid={testId} ref={ref}>
    {title}
  </h1>
));

NsTitle.displayName = 'NsTitle';
